import scope from '../../server-loja/catalog-allowlist.json';
export const catalogVersion=scope.version;
export const allowedProductIds=new Set<number>(scope.products.map(p=>p.id));
export const allowedCategoryIds=new Set<number>(scope.categories.map(c=>c.id));
export function isAllowedProduct(id:number){return allowedProductIds.has(id);}
